import ProductosReservaDetalle from '../../../components/posCita/ProductosReservaDetalle';
// src/pages/citas/EditarCitaPage.tsx
import React, { useEffect, useState, useCallback, useMemo } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import {
    Clock,
    Users,
    MapPin,
    Package,
    Tag,
    CheckCircle2,
    AlertCircle,
    ChevronLeft,
    Save,
    DollarSign,
    UserCheck,
    RefreshCw,
    CreditCard,
    UserPlus,
    X,
    Plus,
    Percent
} from 'lucide-react';
import { DateRange } from 'react-day-picker';
import 'react-day-picker/dist/style.css';
import { DayPicker } from 'react-day-picker';
import { format, addDays, addHours, differenceInMinutes, isWithinInterval } from 'date-fns';
import { es } from 'date-fns/locale';

import {
    fetchCitaById,
    updateCita,
    fetchPrecioPlanesServicios,
    fetchEspacioServicios,
    fetchCategories,
    fetchClientes,
    fetchServiciosByCategory,
    fetchPlanDuracionConfigs,
    fetchCitasPorSucursal,
    Cita,
    PrecioPlanServicio,
    EspacioServicio,
    Categoria,
    Cliente,
    Servicio,
    PlanDuracionConfig
} from '../../../services/citasService';
import {
    obtenerSesionActivaPorId,
    SesionActivaResponse
} from '../../../services/pos/sesionPOSService';
import { fetchPuntoDeVenta } from '../../../services/pos/puntoDeVentaService';
import { OperadorGrantRow, OperadorPinDialog, useOperadorGrant } from '../../../components/pos/OperadorPinDialog';
import { fetchSucursales } from '../../../services/pos/sucursalService';
import { fetchCupones, Cupon, fetchCuponesUsados } from '../../../services/citasService';
import ModalAgregarClientesAsociados from '../../../components/posCita/ModalAgregarClientesAsociados';

interface FormData {
    cliente: number | null;
    clientes_asociados: number[];
    precio_plan_servicio: number | null;
    espacio_servicio: number | null;
    categoria: number | null;
    fecha_inicio: string;
    fecha_fin: string;
    hora_inicio: string;
    hora_fin: string;
    cantidad_periodos: number;
    subtotal: number;
    descuento_directo: number;
    total: number;
    dias_habiles: boolean;
    cupon: number | null;
    observaciones_ingreso: string;
    observaciones_salida: string;
    limpieza_ingreso: boolean;
    limpieza_salida: boolean;
}

interface ClienteAsociadoInfo {
    id: number;
    userId: number;
    first_name: string;
    last_name: string;
    email: string;
}

const EditarCitaPage = () => {
    const { id } = useParams<{ id: string }>();
    const navigate = useNavigate();

    const [citaOriginal, setCitaOriginal] = useState<Cita | null>(null);
    const [formData, setFormData] = useState<FormData>({
        cliente: null,
        clientes_asociados: [],
        precio_plan_servicio: null,
        espacio_servicio: null,
        categoria: null,
        fecha_inicio: '',
        fecha_fin: '',
        hora_inicio: '',
        hora_fin: '',
        cantidad_periodos: 1,
        subtotal: 0,
        descuento_directo: 0,
        total: 0,
        dias_habiles: false,
        cupon: null,
        observaciones_ingreso: '',
        observaciones_salida: '',
        limpieza_ingreso: true,
        limpieza_salida: true
    });

    const [clientes, setClientes] = useState<Cliente[]>([]);
    const [precioPlanes, setPrecioPlanes] = useState<PrecioPlanServicio[]>([]);
    const [espaciosServicio, setEspaciosServicio] = useState<EspacioServicio[]>([]);
    const [categorias, setCategorias] = useState<Categoria[]>([]);
    const [servicios, setServicios] = useState<Servicio[]>([]);
    const [planConfigs, setPlanConfigs] = useState<PlanDuracionConfig[]>([]);
    const [cupones, setCupones] = useState<Cupon[]>([]);
    const [cuponAplicado, setCuponAplicado] = useState<Cupon | null>(null);
    const [cuponCodigo, setCuponCodigo] = useState<string>('');

    const [sesionActiva, setSesionActiva] = useState<SesionActivaResponse | null>(null);
    const [puntoDeVenta, setPuntoDeVenta] = useState<any>(null);
    const [sucursales, setSucursales] = useState<any[]>([]);
    const [sucursalId, setSucursalId] = useState<number | null>(null);

    const [selectedCategory, setSelectedCategory] = useState<Categoria | null>(null);
    const [selectedService, setSelectedService] = useState<Servicio | null>(null);
    const [selectedPlan, setSelectedPlan] = useState<PrecioPlanServicio | null>(null);
    const [selectedSpace, setSelectedSpace] = useState<EspacioServicio | null>(null);
    const [clienteSeleccionado, setClienteSeleccionado] = useState<Cliente | null>(null);

    const [range, setRange] = useState<DateRange | undefined>(undefined);
    const [daySelectionType, setDaySelectionType] = useState<'all' | 'business'>('all');
    const [isDayTypeOpen, setIsDayTypeOpen] = useState(false);
    const [isHoraFinManuallyModified, setIsHoraFinManuallyModified] = useState(false);

    // --- ESTADO PARA TEMPORIZADOR ---
    const [usaTemporizador, setUsaTemporizador] = useState<boolean>(false);

    const [clientesAsociadosInfo, setClientesAsociadosInfo] = useState<ClienteAsociadoInfo[]>([]);
    const [showAgregarClientesModal, setShowAgregarClientesModal] = useState(false);

    const [espaciosDisponibles, setEspaciosDisponibles] = useState<{ [key: number]: boolean }>({});
    const [citasExistentes, setCitasExistentes] = useState<Cita[]>([]);

    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState<string | null>(null);

    // Mutar una cita registrada en caja exige el grant del operador (PIN)
    // sobre su caja persistida; una cita sin caja no puede editarse desde aquí.
    const citaSesionPosId = citaOriginal?.sesion_pos ?? null;
    const operador = useOperadorGrant(citaSesionPosId);
    const puedeGuardar = citaSesionPosId !== null && !!operador.token;
    // Aviso de caja: la cita no tiene caja persistida o esa caja ya no es operable.
    const [cajaAviso, setCajaAviso] = useState<string | null>(null);
    const [success, setSuccess] = useState<string | null>(null);
    const [warning, setWarning] = useState<string | null>(null);

    // Nuevo estado para controlar el mes visible en el calendario
    const [calendarMonth, setCalendarMonth] = useState<Date | undefined>(undefined);

    const theme = {
        primaryAction: '#c1348b',
        corporate: '#8f1f64',
        highlightText: '#ea8406',
        highlightBg: '#ffd97c',
        blue: '#61257b',
        teal: '#8b3fa8',
    };

    console.log({ sesionActiva, puntoDeVenta, sucursales });

    // Función para parsear fecha en formato YYYY-MM-DD sin problemas de zona horaria
    const parseLocalDate = (dateString: string | null | undefined): Date | null => {
        if (!dateString) return null;
        try {
            const [year, month, day] = dateString.split('-').map(Number);
            const date = new Date(year, month - 1, day);
            if (isNaN(date.getTime())) return null;
            return date;
        } catch {
            return null;
        }
    };

    // Función segura para formatear fechas
    const formatDateWithoutTimezone = (date: Date | null | undefined): string => {
        if (!date) return '';
        try {
            const year = date.getFullYear();
            const month = (date.getMonth() + 1).toString().padStart(2, '0');
            const day = date.getDate().toString().padStart(2, '0');
            return `${year}-${month}-${day}`;
        } catch {
            return '';
        }
    };

    // Normalizar hora a formato HH:mm
    const normalizeTime = (timeString: string | null | undefined): string => {
        if (!timeString) return '';
        const parts = timeString.trim().split(':');
        if (parts.length < 2) return '';
        let hours = parseInt(parts[0]) || 0;
        let minutes = parseInt(parts[1]) || 0;
        hours = Math.max(0, Math.min(23, hours));
        minutes = Math.max(0, Math.min(59, minutes));
        return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
    };

    // Función segura para parsear horas
    const parseTimeSafe = useCallback((timeString: string | null | undefined): Date | null => {
        if (!timeString) return null;
        try {
            const normalizedTime = normalizeTime(timeString);
            if (!normalizedTime) return null;
            const [hours, minutes] = normalizedTime.split(':').map(Number);
            const date = new Date();
            date.setHours(hours, minutes, 0, 0);
            return date;
        } catch {
            return null;
        }
    }, []);

    // Helper function para convertir cualquier valor a número
    const safeParseFloat = (value: any): number => {
        if (typeof value === 'number') return value;
        if (typeof value === 'string') return parseFloat(value) || 0;
        return 0;
    };

    // Cargar datos iniciales
    // Cargar datos iniciales
    useEffect(() => {
        const cargarDatosIniciales = async () => {
            if (!id) return;

            setLoading(true);
            setError(null);

            try {
                // La cita se carga PRIMERO: la única caja que puede editarla es
                // la persistida en ``cita.sesion_pos`` (revalidada por id). Con
                // varias cajas abiertas nunca se elige "otra": el endpoint
                // singular (409) no forma parte de esta página.
                const citaData = await fetchCitaById(parseInt(id));
                let sucursalIdValue: number | null = citaData.sucursal ?? null;
                if (citaData.sesion_pos != null) {
                    try {
                        const sesion = await obtenerSesionActivaPorId(citaData.sesion_pos);
                        setSesionActiva(sesion);
                        const puntoVenta = await fetchPuntoDeVenta(sesion.punto_de_venta);
                        setPuntoDeVenta(puntoVenta);
                        sucursalIdValue = puntoVenta.sucursal ?? sucursalIdValue;
                    } catch (posError: any) {
                        console.error('La caja persistida de la cita no está operable:', posError);
                        setSesionActiva(null);
                        setPuntoDeVenta(null);
                        setCajaAviso(
                            posError?.response?.data?.error
                            || posError?.response?.data?.detail
                            || 'La caja que registró esta cita ya no está abierta u operable: no se puede guardar desde aquí.'
                        );
                    }
                } else {
                    setSesionActiva(null);
                    setPuntoDeVenta(null);
                    setCajaAviso('La cita no tiene una caja persistida: no puede editarse desde el POS.');
                }
                setSucursalId(sucursalIdValue);

                const [
                    clientesData,
                    categoriasData,
                    sucursalesData,
                    planConfigsData,
                    cuponesData,
                    precioPlanesData
                ] = await Promise.all([
                    fetchClientes(),
                    fetchCategories(sucursalIdValue ?? undefined),
                    fetchSucursales(),
                    fetchPlanDuracionConfigs(),
                    fetchCupones(),
                    fetchPrecioPlanesServicios()
                ]);

                setCitaOriginal(citaData);
                setClientes(clientesData);
                setCategorias(categoriasData);
                setSucursales(sucursalesData);
                setPlanConfigs(planConfigsData);
                setCupones(cuponesData);
                setPrecioPlanes(precioPlanesData); // Guardamos todos los planes

                // Normalizar horas: si es null, queda vacío
                const horaInicioNormalizada = normalizeTime(citaData.hora_inicio);
                const horaFinNormalizada = citaData.hora_fin ? normalizeTime(citaData.hora_fin) : '';

                setFormData({
                    cliente: citaData.cliente || null,
                    clientes_asociados: citaData.clientes_asociados || [],
                    precio_plan_servicio: citaData.precio_plan_servicio || null,
                    espacio_servicio: citaData.espacio_servicio || null,
                    categoria: citaData.categoria || null,
                    fecha_inicio: citaData.fecha_inicio || '',
                    fecha_fin: citaData.fecha_fin || '',
                    hora_inicio: horaInicioNormalizada,
                    hora_fin: horaFinNormalizada,
                    cantidad_periodos: citaData.cantidad_periodos || 1,
                    subtotal: safeParseFloat(citaData.subtotal) - Number(citaData.total_productos || 0),
                    descuento_directo: safeParseFloat(citaData.descuento_directo),
                    total: safeParseFloat(citaData.total),
                    dias_habiles: citaData.dias_habiles || false,
                    cupon: (citaData as any).cupon || null,
                    observaciones_ingreso: citaData.observaciones_ingreso || '',
                    observaciones_salida: citaData.observaciones_salida || '',
                    limpieza_ingreso: citaData.limpieza_ingreso ?? true,
                    limpieza_salida: citaData.limpieza_salida ?? true
                });

                // Establecer rango de fechas
                if (citaData.fecha_inicio && citaData.fecha_fin) {
                    const fromDate = parseLocalDate(citaData.fecha_inicio);
                    const toDate = parseLocalDate(citaData.fecha_fin);
                    if (fromDate && toDate) {
                        setRange({ from: fromDate, to: toDate });
                        setCalendarMonth(fromDate);
                    }
                }

                setDaySelectionType(citaData.dias_habiles ? 'business' : 'all');

                if (citaData.cliente) {
                    const cliente = clientesData.find(c => c.usuario?.id === citaData.cliente);
                    setClienteSeleccionado(cliente || null);
                }

                if (citaData.clientes_asociados_info) {
                    const clientesInfo = citaData.clientes_asociados_info.map(info => {
                        const cliente = clientesData.find(c => c.usuario?.id === info.id);
                        return {
                            id: cliente?.id || info.id,
                            userId: info.id,
                            first_name: info.first_name,
                            last_name: info.last_name,
                            email: info.email
                        };
                    });
                    setClientesAsociadosInfo(clientesInfo);
                }

                // Determinar si el plan usa temporizador (AHORA CON precioPlanesData DISPONIBLE)
                if (citaData.precio_plan_servicio) {
                    const plan = precioPlanesData.find(p => p.id === citaData.precio_plan_servicio);
                    if (plan) {
                        const config = planConfigsData.find(c => c.id === plan.plan_duracion_config);
                        if (config) {
                            setUsaTemporizador(config.usa_temporizador);
                        }
                    }
                }

                // Cargar servicios y demás según categoría
                if (citaData.categoria) {
                    const categoria = categoriasData.find((c: Categoria) => c.id === citaData.categoria);
                    setSelectedCategory(categoria || null);

                    if (categoria) {
                        const serviciosData = await fetchServiciosByCategory(categoria.id, sucursalIdValue ?? undefined);
                        setServicios(serviciosData);

                        if (citaData.precio_plan_servicio) {
                            const plan = precioPlanesData.find(p => p.id === citaData.precio_plan_servicio);
                            setSelectedPlan(plan || null);

                            if (plan) {
                                const planesDelServicio = precioPlanesData.filter(p => p.servicio === plan.servicio && p.estado);
                                setPrecioPlanes(planesDelServicio);

                                const servicio = serviciosData.find(s => s.id === plan.servicio);
                                setSelectedService(servicio || null);

                                if (servicio?.requiere_espacio) {
                                    const espacios = await fetchEspacioServicios(servicio.id, sucursalIdValue ?? undefined);
                                    setEspaciosServicio(espacios);

                                    if (citaData.espacio_servicio) {
                                        const espacio = espacios.find(e => e.id === citaData.espacio_servicio);
                                        setSelectedSpace(espacio || null);
                                    }
                                }
                            }
                        }
                    }
                }

                if (sucursalIdValue) {
                    try {
                        const citas = await fetchCitasPorSucursal(sucursalIdValue);
                        setCitasExistentes(citas);
                    } catch (err) {
                        console.error('Error al cargar citas existentes:', err);
                        setCitasExistentes([]);
                    }
                }

                const cuponId = (citaData as any).cupon;
                if (cuponId) {
                    const cupon = cuponesData.find(c => c.id === cuponId);
                    setCuponAplicado(cupon || null);
                    if (cupon) {
                        setCuponCodigo(cupon.codigo);
                    }
                }

                console.log('Datos cargados para edición:', citaData);

            } catch (err) {
                console.error('Error cargando datos:', err);
                setError('No se pudo cargar los datos de la cita');
            } finally {
                setLoading(false);
            }
        };

        cargarDatosIniciales();
    }, [id]);

    // Actualizar usaTemporizador cuando cambia el plan seleccionado
    // Efecto para actualizar usaTemporizador cuando cambia el plan seleccionado
    useEffect(() => {
        if (selectedPlan) {
            const config = planConfigs.find(c => c.id === selectedPlan.plan_duracion_config);
            if (config) {
                setUsaTemporizador(config.usa_temporizador);
                // Si el plan tiene temporizador, decidir si limpiamos la hora fin
                if (config.usa_temporizador) {
                    const planOriginal = citaOriginal?.precio_plan_servicio;
                    const horaFinOriginal = citaOriginal?.hora_fin;
                    // Solo limpiamos si el plan es diferente al original O la cita original no tenía hora_fin
                    if (planOriginal !== selectedPlan.id || !horaFinOriginal) {
                        setFormData(prev => ({ ...prev, hora_fin: '' }));
                        setIsHoraFinManuallyModified(false);
                    }
                }
            } else {
                setUsaTemporizador(false);
            }
        }
    }, [selectedPlan, planConfigs, citaOriginal]);
    const totalProductos = Number(citaOriginal?.total_productos || 0);
    // Calcular total automáticamente
    const calcularTotal = useCallback(() => {
        let subtotal = Number(formData.subtotal) || 0;
        let totalDescuento = formData.descuento_directo;

        if (cuponAplicado) {
            if (cuponAplicado.descuento_monto) {
                totalDescuento += Number(cuponAplicado.descuento_monto) || 0;
            } else if (cuponAplicado.descuento_porcentaje) {
                const restante = Math.max(subtotal - totalDescuento, 0);
                totalDescuento += (restante * (Number(cuponAplicado.descuento_porcentaje) || 0)) / 100;
            }
        }

        return Math.max(subtotal - totalDescuento, 0) + totalProductos;
    }, [formData.subtotal, formData.descuento_directo, cuponAplicado, totalProductos]);

    useEffect(() => {
        const totalFinal = calcularTotal();
        setFormData(prev => ({
            ...prev,
            total: totalFinal
        }));
    }, [calcularTotal]);

    // Memoize formData.hora_fin para evitar dependencia cíclica
    const horaFinMemoized = useMemo(() => formData.hora_fin, [formData.hora_fin]);

    // Calcular fechas y precios basados en el plan (incluye lógica de temporizador)
    useEffect(() => {
        if (!selectedPlan || !range?.from || !formData.cantidad_periodos) return;

        const cfg = planConfigs.find(c => c.id === selectedPlan.plan_duracion_config);
        if (!cfg) return;

        const addBusinessDays = (startDate: Date, daysToAdd: number): Date => {
            const result = new Date(startDate);
            let added = 0;
            while (added < daysToAdd) {
                result.setDate(result.getDate() + 1);
                if (result.getDay() !== 0 && result.getDay() !== 6) {
                    added++;
                }
            }
            return result;
        };

        // --- RAMA PARA PLANES CON TEMPORIZADOR ---
        if (cfg.usa_temporizador) {
            // Solo se soporta unidad 'dia' para temporizador (como en NuevaCitaPage)
            if (cfg.unidad === 'dia' && cfg.dias) {
                const totalDays = formData.cantidad_periodos * cfg.dias;
                const newEnd = daySelectionType === 'business'
                    ? addBusinessDays(range.from, totalDays - 1)
                    : addDays(range.from, totalDays - 1);

                setRange({ from: range.from, to: newEnd });
                setFormData(prev => ({
                    ...prev,
                    fecha_fin: formatDateWithoutTimezone(newEnd)
                }));

                // Calcular subtotal
                if (selectedPlan.precio_posterior != null && selectedPlan.duracion_inicial) {
                    const di = selectedPlan.duracion_inicial;
                    const pi = Number(selectedPlan.precio_inicial) || 0;
                    const pp = Number(selectedPlan.precio_posterior) || 0;
                    const initialCount = Math.min(formData.cantidad_periodos, di);
                    const posteriorCount = Math.max(formData.cantidad_periodos - di, 0);
                    const newSubtotal = (initialCount * pi) + (posteriorCount * pp);

                    setFormData(prev => ({
                        ...prev,
                        subtotal: newSubtotal
                    }));
                } else {
                    const newSubtotal = (Number(selectedPlan.precio_inicial) || 0) * formData.cantidad_periodos;
                    setFormData(prev => ({
                        ...prev,
                        subtotal: newSubtotal
                    }));
                }
            }
            // No se calcula hora fin automáticamente
            return;
        }

        // --- LÓGICA NORMAL (SIN TEMPORIZADOR) ---
        if (cfg.unidad === 'dia' && cfg.dias) {
            const totalDays = formData.cantidad_periodos * cfg.dias;
            const newEnd = daySelectionType === 'business'
                ? addBusinessDays(range.from, totalDays - 1)
                : addDays(range.from, totalDays - 1);

            setRange({ from: range.from, to: newEnd });
            setFormData(prev => ({
                ...prev,
                fecha_fin: formatDateWithoutTimezone(newEnd)
            }));

            if (selectedPlan.precio_posterior != null && selectedPlan.duracion_inicial) {
                const di = selectedPlan.duracion_inicial;
                const pi = Number(selectedPlan.precio_inicial) || 0;
                const pp = Number(selectedPlan.precio_posterior) || 0;
                const initialCount = Math.min(formData.cantidad_periodos, di);
                const posteriorCount = Math.max(formData.cantidad_periodos - di, 0);
                const newSubtotal = (initialCount * pi) + (posteriorCount * pp);

                setFormData(prev => ({
                    ...prev,
                    subtotal: newSubtotal
                }));
            } else {
                const newSubtotal = (Number(selectedPlan.precio_inicial) || 0) * formData.cantidad_periodos;
                setFormData(prev => ({
                    ...prev,
                    subtotal: newSubtotal
                }));
            }

            if (formData.hora_inicio && cfg.horas !== null && !isHoraFinManuallyModified) {
                const startTime = parseTimeSafe(formData.hora_inicio);
                if (startTime) {
                    const endTime = addHours(startTime, cfg.horas);
                    setFormData(prev => ({
                        ...prev,
                        hora_fin: format(endTime, 'HH:mm')
                    }));
                }
            }
        }

        if (cfg.unidad === 'hora' && cfg.horas !== null && cfg.dias !== null) {
            const totalDays = formData.cantidad_periodos * cfg.dias;
            const newEndDate = daySelectionType === 'business'
                ? addBusinessDays(range.from, totalDays - 1)
                : addDays(range.from, totalDays - 1);

            setRange({ from: range.from, to: newEndDate });
            setFormData(prev => ({
                ...prev,
                fecha_fin: formatDateWithoutTimezone(newEndDate)
            }));

            if (formData.hora_inicio && !isHoraFinManuallyModified) {
                const startTime = parseTimeSafe(formData.hora_inicio);
                if (startTime) {
                    const defaultEnd = addHours(startTime, cfg.horas);
                    setFormData(prev => ({
                        ...prev,
                        hora_fin: format(defaultEnd, 'HH:mm')
                    }));
                }
            }

            if (!formData.hora_inicio || !horaFinMemoized) return;

            const startTime = parseTimeSafe(formData.hora_inicio);
            const endTime = parseTimeSafe(horaFinMemoized);

            if (!startTime || !endTime) return;

            const minutesDiff = differenceInMinutes(endTime, startTime);
            const hoursSelected = minutesDiff / 60;

            if (selectedPlan.precio_posterior && selectedPlan.duracion_inicial) {
                let remainingInitialDuration = selectedPlan.duracion_inicial;
                let total = 0;

                for (let day = 0; day < totalDays; day++) {
                    if (remainingInitialDuration <= 0) {
                        total += hoursSelected * (Number(selectedPlan.precio_posterior) || 0);
                    } else {
                        const initialHours = Math.min(hoursSelected, remainingInitialDuration);
                        const posteriorHours = hoursSelected - initialHours;
                        total += (initialHours * (Number(selectedPlan.precio_inicial) || 0)) +
                            (posteriorHours * (Number(selectedPlan.precio_posterior) || 0));
                        remainingInitialDuration -= initialHours;
                    }
                }

                setFormData(prev => ({
                    ...prev,
                    subtotal: Math.round(total) || 0
                }));
            } else {
                const pricePerHour = (Number(selectedPlan.precio_inicial) || 0) / cfg.horas;
                const total = pricePerHour * hoursSelected * totalDays;
                setFormData(prev => ({
                    ...prev,
                    subtotal: Math.round(total) || 0
                }));
            }
        }
    }, [selectedPlan, range?.from, formData.cantidad_periodos, formData.hora_inicio, horaFinMemoized, planConfigs, isHoraFinManuallyModified, daySelectionType, parseTimeSafe]);

    // Verificar disponibilidad de espacios
    const verificarDisponibilidadEspacios = useCallback(() => {
        if (!selectedService?.requiere_espacio) return;
        if (!formData.fecha_inicio || !formData.fecha_fin || !formData.hora_inicio) return;

        const disponibilidad: { [key: number]: boolean } = {};

        espaciosServicio.forEach(espacio => {
            const tieneSuperposicion = citasExistentes.some(cita => {
                if (cita.id === parseInt(id!)) return false;
                if (cita.espacio_servicio !== espacio.id) return false;
                if (cita.estado !== 'Confirmada' && cita.estado !== 'Pendiente') return false;

                try {
                    const citaHoraInicio = normalizeTime(cita.hora_inicio);
                    const citaHoraFin = normalizeTime(cita.hora_fin);
                    const seleccionHoraInicio = normalizeTime(formData.hora_inicio);
                    // Si la cita actual no tiene hora_fin (temporizador), considerar fin del día
                    const seleccionHoraFin = formData.hora_fin ? normalizeTime(formData.hora_fin) : '23:59';

                    const citaFechaInicio = parseLocalDate(cita.fecha_inicio);
                    const citaFechaFin = parseLocalDate(cita.fecha_fin);
                    const seleccionFechaInicio = parseLocalDate(formData.fecha_inicio);
                    const seleccionFechaFin = parseLocalDate(formData.fecha_fin);

                    if (!citaFechaInicio || !citaFechaFin || !seleccionFechaInicio || !seleccionFechaFin) {
                        return false;
                    }

                    const citaInicio = new Date(
                        citaFechaInicio.getFullYear(),
                        citaFechaInicio.getMonth(),
                        citaFechaInicio.getDate(),
                        parseInt(citaHoraInicio.split(':')[0]),
                        parseInt(citaHoraInicio.split(':')[1])
                    );

                    const citaFin = new Date(
                        citaFechaFin.getFullYear(),
                        citaFechaFin.getMonth(),
                        citaFechaFin.getDate(),
                        parseInt(citaHoraFin.split(':')[0]),
                        parseInt(citaHoraFin.split(':')[1])
                    );

                    const seleccionInicio = new Date(
                        seleccionFechaInicio.getFullYear(),
                        seleccionFechaInicio.getMonth(),
                        seleccionFechaInicio.getDate(),
                        parseInt(seleccionHoraInicio.split(':')[0]),
                        parseInt(seleccionHoraInicio.split(':')[1])
                    );

                    const seleccionFin = new Date(
                        seleccionFechaFin.getFullYear(),
                        seleccionFechaFin.getMonth(),
                        seleccionFechaFin.getDate(),
                        parseInt(seleccionHoraFin.split(':')[0]),
                        parseInt(seleccionHoraFin.split(':')[1])
                    );

                    return (
                        isWithinInterval(seleccionInicio, { start: citaInicio, end: citaFin }) ||
                        isWithinInterval(seleccionFin, { start: citaInicio, end: citaFin }) ||
                        isWithinInterval(citaInicio, { start: seleccionInicio, end: seleccionFin }) ||
                        isWithinInterval(citaFin, { start: seleccionInicio, end: seleccionFin })
                    );
                } catch {
                    return false;
                }
            });

            disponibilidad[espacio.id] = !tieneSuperposicion;
        });

        setEspaciosDisponibles(disponibilidad);
    }, [formData.fecha_inicio, formData.fecha_fin, formData.hora_inicio, formData.hora_fin, citasExistentes, espaciosServicio, selectedService, id]);

    useEffect(() => {
        if (selectedService?.requiere_espacio) {
            verificarDisponibilidadEspacios();
        }
    }, [formData.fecha_inicio, formData.fecha_fin, formData.hora_inicio, formData.hora_fin, citasExistentes, espaciosServicio, selectedService, verificarDisponibilidadEspacios]);

    // Manejadores de cambios
    const handleCategoryChange = async (categoryId: number) => {
        const categoria = categorias.find(c => c.id === categoryId);
        setSelectedCategory(categoria || null);

        setFormData(prev => ({
            ...prev,
            categoria: categoryId,
            precio_plan_servicio: null,
            espacio_servicio: null
        }));

        setSelectedService(null);
        setSelectedPlan(null);
        setSelectedSpace(null);

        try {
            const serviciosData = await fetchServiciosByCategory(categoryId, sucursalId || undefined);
            setServicios(serviciosData);
            setPrecioPlanes([]);
        } catch (err) {
            console.error('Error cargando servicios:', err);
            setError('Error al cargar servicios para esta categoría');
        }
    };

    const handleServiceChange = async (servicioId: number) => {
        const servicio = servicios.find(s => s.id === servicioId);
        setSelectedService(servicio || null);

        setFormData(prev => ({
            ...prev,
            precio_plan_servicio: null,
            espacio_servicio: null
        }));

        setSelectedPlan(null);
        setSelectedSpace(null);

        try {
            const precioPlanesData = await fetchPrecioPlanesServicios();
            const filteredPlans = precioPlanesData.filter(p => p.servicio === servicioId && p.estado);
            setPrecioPlanes(filteredPlans);

            if (servicio?.requiere_espacio) {
                const espacios = await fetchEspacioServicios(servicioId, sucursalId || undefined);
                setEspaciosServicio(espacios);
            } else {
                setEspaciosServicio([]);
            }
        } catch (err) {
            console.error('Error cargando planes:', err);
            setError('Error al cargar planes para este servicio');
        }
    };

    const handlePlanChange = (planId: number) => {
        const plan = precioPlanes.find(p => p.id === planId);
        setSelectedPlan(plan || null);

        setFormData(prev => ({
            ...prev,
            precio_plan_servicio: planId
        }));
    };

    const handleSpaceChange = (espacioId: number) => {
        const espacio = espaciosServicio.find(e => e.id === espacioId);
        setSelectedSpace(espacio || null);

        setFormData(prev => ({
            ...prev,
            espacio_servicio: espacioId
        }));

        if (espacio) {
            const totalPersonas = (formData.cliente ? 1 : 0) + formData.clientes_asociados.length;
            if (totalPersonas > espacio.cantidad_personas) {
                setWarning(`Advertencia: El espacio tiene capacidad para ${espacio.cantidad_personas} personas, pero se están asignando ${totalPersonas}`);
            } else {
                setWarning(null);
            }
        }
    };

    const handleClienteChange = (clienteId: number) => {
        const cliente = clientes.find(c => c.usuario?.id === clienteId);
        setClienteSeleccionado(cliente || null);

        setFormData(prev => ({
            ...prev,
            cliente: clienteId
        }));

        if (selectedSpace) {
            const totalPersonas = (clienteId ? 1 : 0) + formData.clientes_asociados.length;
            if (totalPersonas > selectedSpace.cantidad_personas) {
                setWarning(`Advertencia: El espacio tiene capacidad para ${selectedSpace.cantidad_personas} personas, pero se están asignando ${totalPersonas}`);
            } else {
                setWarning(null);
            }
        }
    };

    const handleAgregarClientesAsociados = (clientesIds: number[]) => {
        const usuariosIds = clientes
            .filter(cliente => clientesIds.includes(cliente.id) && cliente.usuario && cliente.usuario.id !== formData.cliente && !formData.clientes_asociados.includes(cliente.usuario.id))
            .map(cliente => cliente.usuario!.id);

        const nuevosClientesAsociados = Array.from(new Set([...formData.clientes_asociados, ...usuariosIds]));

        setFormData(prev => ({
            ...prev,
            clientes_asociados: nuevosClientesAsociados
        }));

        const nuevosClientesInfo = clientes
            .filter(cliente => clientesIds.includes(cliente.id) && cliente.usuario && cliente.usuario.id !== formData.cliente && !formData.clientes_asociados.includes(cliente.usuario.id))
            .map(cliente => ({
                id: cliente.id,
                userId: cliente.usuario!.id,
                first_name: cliente.usuario!.first_name,
                last_name: cliente.usuario!.last_name,
                email: cliente.usuario!.email
            }));

        setClientesAsociadosInfo([...clientesAsociadosInfo, ...nuevosClientesInfo]);
        setShowAgregarClientesModal(false);

        if (selectedSpace) {
            const totalPersonas = (formData.cliente ? 1 : 0) + nuevosClientesAsociados.length;
            if (totalPersonas > selectedSpace.cantidad_personas) {
                setWarning(`Advertencia: El espacio tiene capacidad para ${selectedSpace.cantidad_personas} personas, pero se están asignando ${totalPersonas}`);
            } else {
                setWarning(null);
            }
        }
    };

    const handleRemoverClienteAsociado = (clienteId: number) => {
        const clienteInfo = clientesAsociadosInfo.find(info => info.id === clienteId);
        if (clienteInfo) {
            const nuevosClientesAsociados = formData.clientes_asociados.filter(id => id !== clienteInfo.userId);
            setFormData(prev => ({
                ...prev,
                clientes_asociados: nuevosClientesAsociados
            }));
            setClientesAsociadosInfo(clientesAsociadosInfo.filter(info => info.id !== clienteId));

            if (selectedSpace) {
                const totalPersonas = (formData.cliente ? 1 : 0) + nuevosClientesAsociados.length;
                if (totalPersonas > selectedSpace.cantidad_personas) {
                    setWarning(`Advertencia: El espacio tiene capacidad para ${selectedSpace.cantidad_personas} personas, pero se están asignando ${totalPersonas}`);
                } else {
                    setWarning(null);
                }
            }
        }
    };

    const validarCupon = async () => {
        if (!cuponCodigo.trim()) {
            setCuponAplicado(null);
            setFormData(prev => ({ ...prev, cupon: null }));
            return;
        }

        const cuponEncontrado = cupones.find(
            (c) => c.codigo.trim().toUpperCase() === cuponCodigo.trim().toUpperCase()
        );

        if (!cuponEncontrado) {
            setError('Cupón no válido');
            setCuponAplicado(null);
            setFormData(prev => ({ ...prev, cupon: null }));
            return;
        }

        const ahora = new Date();
        const fechaInicio = new Date(cuponEncontrado.fecha_inicio);
        const fechaFin = new Date(cuponEncontrado.fecha_fin);

        if (!(fechaInicio <= ahora && ahora <= fechaFin)) {
            setError('El cupón está fuera de vigencia');
            setCuponAplicado(null);
            setFormData(prev => ({ ...prev, cupon: null }));
            return;
        }

        if (cuponEncontrado.uso_unico_por_cliente && formData.cliente) {
            try {
                const cuponesUsados = await fetchCuponesUsados();
                const yaUsado = cuponesUsados.find(
                    (u) => Number(u.cliente) === Number(formData.cliente) &&
                        Number(u.cupon) === Number(cuponEncontrado.id) &&
                        Number(u.cita) !== Number(id)
                );

                if (yaUsado) {
                    setError('Este cupón ya fue usado por este cliente');
                    setCuponAplicado(null);
                    setFormData(prev => ({ ...prev, cupon: null }));
                    return;
                }
            } catch (err) {
                console.error('Error al verificar cupones usados:', err);
                setError('No se pudo validar el uso del cupón');
                return;
            }
        }

        if (cuponEncontrado.plan_aplicable?.id && selectedPlan?.id !== cuponEncontrado.plan_aplicable.id) {
            setError(`Este cupón solo aplica para el plan "${cuponEncontrado.plan_aplicable.plan_nombre}"`);
            setCuponAplicado(null);
            setFormData(prev => ({ ...prev, cupon: null }));
            return;
        }

        setCuponAplicado(cuponEncontrado);
        setFormData(prev => ({ ...prev, cupon: cuponEncontrado.id }));
        setSuccess('Cupón aplicado correctamente');
    };

    const validarFormulario = (): boolean => {
        const errores: string[] = [];

        if (!formData.categoria) errores.push('Debe seleccionar una categoría');
        if (!selectedService) errores.push('Debe seleccionar un servicio');
        if (!formData.precio_plan_servicio) errores.push('Debe seleccionar un plan');
        if (selectedService?.requiere_espacio && !formData.espacio_servicio) errores.push('Este servicio requiere un espacio físico');
        if (!formData.fecha_inicio || !formData.fecha_fin) errores.push('Las fechas de inicio y fin son requeridas');
        if (!formData.hora_inicio) errores.push('La hora de inicio es requerida');
        // La hora de fin solo es requerida si no usa temporizador
        if (!usaTemporizador && !formData.hora_fin) errores.push('La hora de fin es requerida');
        if (!formData.cliente) errores.push('Debe seleccionar un cliente titular');
        if (!formData.cantidad_periodos || formData.cantidad_periodos < 1) errores.push('La cantidad de periodos debe ser al menos 1');

        if (formData.fecha_inicio && formData.fecha_fin) {
            const inicio = parseLocalDate(formData.fecha_inicio);
            const fin = parseLocalDate(formData.fecha_fin);
            if (!inicio || !fin) errores.push('Fechas inválidas');
            else if (fin < inicio) errores.push('La fecha de fin no puede ser anterior a la fecha de inicio');
        }

        if (formData.hora_inicio && formData.hora_fin && !usaTemporizador) {
            const horaInicioNormalizada = normalizeTime(formData.hora_inicio);
            const horaFinNormalizada = normalizeTime(formData.hora_fin);
            const timeRegex = /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/;
            if (!timeRegex.test(horaInicioNormalizada) || !timeRegex.test(horaFinNormalizada)) {
                errores.push('Formato de hora inválido. Use formato HH:mm (ej: 09:00, 14:30)');
            } else {
                const [h1, m1] = horaInicioNormalizada.split(':').map(Number);
                const [h2, m2] = horaFinNormalizada.split(':').map(Number);
                if (h2 * 60 + m2 <= h1 * 60 + m1) {
                    errores.push('La hora de fin debe ser posterior a la hora de inicio');
                }
            }
        }

        if (selectedSpace) {
            const totalPersonas = (formData.cliente ? 1 : 0) + formData.clientes_asociados.length;
            if (totalPersonas > selectedSpace.cantidad_personas) {
                errores.push(`La capacidad del espacio (${selectedSpace.cantidad_personas} personas) es menor al total de personas asignadas (${totalPersonas})`);
            }
        }

        if (errores.length > 0) {
            setError(errores.join('. '));
            return false;
        }

        return true;
    };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();

        if (!validarFormulario()) return;

        if (formData.precio_plan_servicio === null) {
            setError('Debe seleccionar un plan');
            return;
        }
        if (citaSesionPosId === null) {
            setError('Esta cita no fue registrada en una caja POS y no puede modificarse desde aquí.');
            return;
        }
        if (!operador.token) {
            setError('Identifica al operador de caja con su PIN antes de guardar.');
            return;
        }
        const grantToken = operador.token;

        setSaving(true);
        setError(null);

        try {
            const datosActualizacion: any = {
                cliente: formData.cliente,
                precio_plan_servicio: formData.precio_plan_servicio,
                espacio_servicio: formData.espacio_servicio,
                categoria: formData.categoria,
                fecha_inicio: formData.fecha_inicio,
                fecha_fin: formData.fecha_fin,
                hora_inicio: normalizeTime(formData.hora_inicio),
                // Si usa temporizador, hora_fin se envía como null
                hora_fin: usaTemporizador
                    ? (formData.hora_fin || null)
                    : normalizeTime(formData.hora_fin),
                cantidad_periodos: formData.cantidad_periodos || 1,
                subtotal: formData.subtotal,
                descuento_directo: formData.descuento_directo,
                total: formData.total,
                dias_habiles: daySelectionType === 'business',
                clientes_asociados: formData.clientes_asociados || [],
                cupon: formData.cupon,
                observaciones_ingreso: formData.observaciones_ingreso,
                observaciones_salida: formData.observaciones_salida,
                limpieza_ingreso: formData.limpieza_ingreso,
                limpieza_salida: formData.limpieza_salida
            };

            // Eliminar campos nulos o undefined
            Object.keys(datosActualizacion).forEach(key => {
                if (datosActualizacion[key] === null || datosActualizacion[key] === undefined) {
                    delete datosActualizacion[key];
                }
            });

            await updateCita(parseInt(id!), datosActualizacion, grantToken);

            setSuccess('¡Cita actualizada correctamente! Las sesiones han sido regeneradas.');
            setTimeout(() => {
                navigate(`/reservas/detalle/${id}`);
            }, 2000);

        } catch (err: any) {
            console.error('Error actualizando cita:', err);
            setError(err.response?.data?.detail || err.message || 'Error al actualizar la cita. Por favor, verifique los datos.');
        } finally {
            setSaving(false);
        }
    };

    const formatNumber = (value: any): string => {
        if (typeof value === 'number') return value.toFixed(2);
        const num = parseFloat(value);
        return isNaN(num) ? '0.00' : num.toFixed(2);
    };

    if (loading) {
        return (
            <div className="min-h-screen bg-gray-50/50 flex items-center justify-center">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2" style={{ borderColor: theme.primaryAction }}></div>
            </div>
        );
    }

    return (
        <div className="min-h-screen bg-gray-50/50">
            <div className="mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl py-8">
                {/* Header */}
                <div className="mb-8">
                    <Link
                        to={`/reservas/detalle/${id}`}
                        className="inline-flex items-center gap-2 text-sm font-medium text-gray-600 hover:text-[#8f1f64] mb-4 transition-colors"
                    >
                        <ChevronLeft className="h-4 w-4" />
                        Volver a detalles de cita
                    </Link>

                    <div className="flex items-center justify-between">
                        <div>
                            <h1 className="text-2xl font-bold text-gray-900 flex items-center gap-3">
                                <RefreshCw className="h-7 w-7" style={{ color: theme.corporate }} />
                                Editar Cita: {citaOriginal?.codigo || `CITA-${id}`}
                            </h1>
                            <p className="text-gray-600 mt-2">
                                Actualice los datos de la cita. Los cambios en fechas y horas regenerarán las sesiones automáticamente.
                            </p>
                        </div>
                    </div>
                </div>

                {/* Mensajes de estado */}
                {error && (
                    <div className="mb-6 p-4 bg-red-50 border border-red-200 rounded-lg">
                        <div className="flex items-center gap-2 text-red-700">
                            <AlertCircle className="h-5 w-5" />
                            <span className="font-medium">Error: {error}</span>
                        </div>
                    </div>
                )}

                {success && (
                    <div className="mb-6 p-4 bg-green-50 border border-green-200 rounded-lg">
                        <div className="flex items-center gap-2 text-green-700">
                            <CheckCircle2 className="h-5 w-5" />
                            <span className="font-medium">{success}</span>
                        </div>
                    </div>
                )}

                {warning && (
                    <div className="mb-6 p-4 bg-yellow-50 border border-yellow-200 rounded-lg">
                        <div className="flex items-center gap-2 text-yellow-700">
                            <AlertCircle className="h-5 w-5" />
                            <span className="font-medium">{warning}</span>
                        </div>
                    </div>
                )}

                {/* Formulario */}
                {citaOriginal && <ProductosReservaDetalle cita={citaOriginal}/>}
                <form onSubmit={handleSubmit} className="bg-white rounded-xl border border-gray-200 shadow-sm">
                    <div className="p-6">
                        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                            {/* Columna izquierda */}
                            <div className="space-y-6">
                                {/* Categoría */}
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                        <Tag className="h-4 w-4 inline mr-2" />
                                        Categoría *
                                    </label>
                                    <select
                                        value={formData.categoria || ''}
                                        onChange={(e) => handleCategoryChange(parseInt(e.target.value))}
                                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#8f1f64] focus:border-transparent"
                                        required
                                    >
                                        <option value="">Seleccione una categoría</option>
                                        {categorias.map(cat => (
                                            <option key={cat.id} value={cat.id}>
                                                {cat.nombre}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                {/* Servicio */}
                                {selectedCategory && (
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            <Package className="h-4 w-4 inline mr-2" />
                                            Servicio *
                                        </label>
                                        <select
                                            value={selectedService?.id || ''}
                                            onChange={(e) => handleServiceChange(parseInt(e.target.value))}
                                            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#8f1f64] focus:border-transparent"
                                            required
                                        >
                                            <option value="">Seleccione un servicio</option>
                                            {servicios.map(srv => (
                                                <option key={srv.id} value={srv.id}>
                                                    {srv.nombre} {srv.requiere_espacio ? '(Requiere espacio)' : ''}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                )}

                                {/* Plan */}
                                {selectedService && (
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            <CreditCard className="h-4 w-4 inline mr-2" />
                                            Plan *
                                        </label>
                                        <select
                                            value={formData.precio_plan_servicio || ''}
                                            onChange={(e) => handlePlanChange(parseInt(e.target.value))}
                                            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#8f1f64] focus:border-transparent"
                                            required
                                        >
                                            <option value="">Seleccione un plan</option>
                                            {precioPlanes.map(plan => {
                                                const config = planConfigs.find(c => c.id === plan.plan_duracion_config);
                                                const esTemporizador = config?.usa_temporizador || false;
                                                return (
                                                    <option key={plan.id} value={plan.id}>
                                                        {plan.plan_nombre} - Bs {formatNumber(plan.precio_inicial)}
                                                        {plan.precio_posterior && ` (Posterior: Bs ${formatNumber(plan.precio_posterior)})`}
                                                        {esTemporizador && ' (Temporizador)'}
                                                    </option>
                                                );
                                            })}
                                        </select>
                                        {selectedPlan && (
                                            <div className="mt-2 p-3 bg-blue-50 rounded-lg">
                                                <div className="text-sm">
                                                    <p className="font-medium">{selectedPlan.servicio_nombre} - {selectedPlan.plan_nombre}</p>
                                                    {selectedPlan.duracion_inicial && (
                                                        <p className="text-gray-600">
                                                            Duración inicial: {selectedPlan.duracion_inicial} horas
                                                        </p>
                                                    )}
                                                    {usaTemporizador && (
                                                        <span className="inline-flex items-center mt-2 px-2 py-1 rounded-full text-xs bg-yellow-100 text-yellow-800">
                                                            <Clock size={12} className="mr-1" />
                                                            Temporizador activo
                                                        </span>
                                                    )}
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                )}

                                {/* Espacio de servicio (condicional) */}
                                {selectedService?.requiere_espacio && (
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            <MapPin className="h-4 w-4 inline mr-2" />
                                            Espacio de Servicio *
                                        </label>
                                        <div className="space-y-3">
                                            {espaciosServicio.map(esp => {
                                                const estaDisponible = espaciosDisponibles[esp.id] !== false;

                                                return (
                                                    <div
                                                        key={esp.id}
                                                        onClick={() => estaDisponible && handleSpaceChange(esp.id)}
                                                        className={`p-4 rounded-lg border cursor-pointer transition-all ${selectedSpace?.id === esp.id
                                                            ? 'border-[#8f1f64] bg-[#8f1f64]/5'
                                                            : 'border-gray-200 hover:border-[#8f1f64]'
                                                            } ${!estaDisponible ? 'opacity-50 cursor-not-allowed' : ''}`}
                                                    >
                                                        <div className="flex justify-between items-center">
                                                            <div>
                                                                <h4 className="font-medium">{esp.espacio_nombre}</h4>
                                                                <p className="text-sm text-gray-600">
                                                                    Capacidad: {esp.cantidad_personas} personas
                                                                </p>
                                                            </div>
                                                            <div className={`px-3 py-1 rounded-full text-xs font-medium ${estaDisponible
                                                                ? 'bg-green-100 text-green-800'
                                                                : 'bg-red-100 text-red-800'
                                                                }`}>
                                                                {estaDisponible ? 'Disponible' : 'Ocupado'}
                                                            </div>
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                        {espaciosServicio.length === 0 && (
                                            <div className="mt-2 p-3 bg-yellow-50 rounded-lg">
                                                <p className="text-sm text-yellow-700">
                                                    No hay espacios disponibles para este servicio en la sucursal actual.
                                                </p>
                                            </div>
                                        )}
                                    </div>
                                )}

                                {/* Cliente titular */}
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                        <UserCheck className="h-4 w-4 inline mr-2" />
                                        Cliente Titular *
                                    </label>
                                    <select
                                        value={formData.cliente || ''}
                                        onChange={(e) => handleClienteChange(parseInt(e.target.value))}
                                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#8f1f64] focus:border-transparent"
                                        required
                                    >
                                        <option value="">Seleccione un cliente</option>
                                        {clientes.map(cliente => (
                                            <option key={cliente.id} value={cliente.usuario?.id}>
                                                {cliente.usuario?.first_name} {cliente.usuario?.last_name} - {cliente.usuario?.email} {cliente.declaracion_jurada_firmada ? '🟢 [Dec. Firmada]' : '🟡 [Firma Pendiente]'}
                                            </option>
                                        ))}
                                    </select>

                                    {clienteSeleccionado && (
                                        <div className="mt-2">
                                            {clienteSeleccionado.declaracion_jurada_firmada ? (
                                                <div className="p-2.5 bg-emerald-50 border border-emerald-200 rounded-lg flex items-center justify-between">
                                                    <div className="flex items-center gap-2">
                                                        <CheckCircle2 className="h-4 w-4 text-emerald-600 flex-shrink-0" />
                                                        <span className="text-xs font-bold text-emerald-800">
                                                            Declaración Jurada Firmada {clienteSeleccionado.fecha_declaracion_jurada ? `(${new Date(clienteSeleccionado.fecha_declaracion_jurada).toLocaleDateString('es-ES')})` : ''}
                                                        </span>
                                                    </div>
                                                    {clienteSeleccionado.foto_declaracion_jurada_url && (
                                                        <a
                                                            href={clienteSeleccionado.foto_declaracion_jurada_url}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            className="text-xs text-[#61257b] hover:underline font-bold"
                                                        >
                                                            Ver Foto
                                                        </a>
                                                    )}
                                                </div>
                                            ) : (
                                                <div className="p-2.5 bg-amber-50 border border-amber-200 rounded-lg flex items-center gap-2">
                                                    <AlertCircle className="h-4 w-4 text-amber-600 flex-shrink-0" />
                                                    <span className="text-xs font-bold text-amber-800">
                                                        Declaración Jurada Pendiente de Firma
                                                    </span>
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </div>

                                {/* Clientes Asociados */}
                                <div className="bg-gray-50 rounded-xl p-5 border border-gray-200">
                                    <div className="flex justify-between items-center mb-4">
                                        <h3 className="font-bold text-gray-700 flex items-center">
                                            <UserPlus size={18} className="mr-2" />
                                            Clientes Asociados
                                        </h3>
                                        <button
                                            type="button"
                                            onClick={() => setShowAgregarClientesModal(true)}
                                            className="px-3 py-2 bg-[#e6f2fa] text-[#61257b] hover:bg-[#cce6f5] rounded-lg text-sm font-medium flex items-center transition-colors"
                                        >
                                            <Plus size={14} className="mr-1" />
                                            Agregar
                                        </button>
                                    </div>

                                    {clientesAsociadosInfo.length === 0 ? (
                                        <div className="text-center py-4">
                                            <UserPlus size={32} className="text-gray-300 mx-auto mb-2" />
                                            <p className="text-sm text-gray-500">
                                                Agregue clientes adicionales que tendrán acceso a la cita.
                                            </p>
                                        </div>
                                    ) : (
                                        <div className="space-y-2">
                                            {clientesAsociadosInfo.map(cliente => (
                                                <div key={cliente.id} className="flex items-center justify-between p-3 bg-white rounded-lg border">
                                                    <div className="flex-1">
                                                        <p className="font-medium text-sm">{cliente.first_name} {cliente.last_name}</p>
                                                        <p className="text-xs text-gray-500 truncate">{cliente.email}</p>
                                                    </div>
                                                    <button
                                                        type="button"
                                                        onClick={() => handleRemoverClienteAsociado(cliente.id)}
                                                        className="p-1.5 text-red-500 hover:text-red-700 hover:bg-red-50 rounded-full transition-colors"
                                                    >
                                                        <X size={16} />
                                                    </button>
                                                </div>
                                            ))}
                                        </div>
                                    )}

                                    {/* Validación de capacidad */}
                                    {selectedSpace && selectedSpace.cantidad_personas && (
                                        <div className="mt-4 p-3 bg-[#e6f2fa] rounded-lg">
                                            <div className="flex items-center justify-between mb-2">
                                                <div className="flex items-center text-sm text-[#0066a6]">
                                                    <Users size={14} className="mr-2" />
                                                    Capacidad del espacio:
                                                </div>
                                                <span className="font-bold text-[#0066a6]">{selectedSpace.cantidad_personas}</span>
                                            </div>
                                            <div className="flex items-center justify-between text-sm">
                                                <span className="text-gray-700">Total personas:</span>
                                                <span className={`font-bold ${(1 + clientesAsociadosInfo.length) > selectedSpace.cantidad_personas
                                                    ? 'text-red-600'
                                                    : 'text-green-600'
                                                    }`}>
                                                    {1 + clientesAsociadosInfo.length}
                                                </span>
                                            </div>
                                            {(1 + clientesAsociadosInfo.length) > selectedSpace.cantidad_personas && (
                                                <p className="text-xs text-red-600 mt-2 font-medium">
                                                    ¡Excede la capacidad máxima del espacio!
                                                </p>
                                            )}
                                        </div>
                                    )}
                                </div>
                            </div>

                            {/* Columna derecha */}
                            <div className="space-y-6">
                                {/* Selección de días */}
                                <div className="mb-8 p-6 bg-gradient-to-r from-gray-50 to-white border border-gray-200 rounded-xl shadow-sm">
                                    <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
                                        <div className="flex-1">
                                            <h3 className="font-bold text-lg text-gray-800 mb-2">Selección de días</h3>
                                            <p className="text-gray-600">
                                                Este botón le permite elegir si la reserva incluirá todos los días o solo días hábiles.
                                            </p>
                                        </div>
                                        <div className="flex-shrink-0">
                                            <div className="relative">
                                                <button
                                                    type="button"
                                                    onClick={() => setIsDayTypeOpen(!isDayTypeOpen)}
                                                    className="flex items-center px-6 py-3 bg-white border-2 border-gray-300 rounded-lg hover:border-[#8f1f64] transition-all shadow-sm min-w-[180px]"
                                                >
                                                    <Clock size={18} className="mr-3 text-gray-500" />
                                                    <div className="text-left">
                                                        <div className="font-medium">
                                                            {daySelectionType === 'all' ? 'Todos los días' : 'Días hábiles'}
                                                        </div>
                                                        <div className="text-xs text-gray-500">
                                                            {daySelectionType === 'all' ? 'Incluye fines de semana' : 'Solo lunes a viernes'}
                                                        </div>
                                                    </div>
                                                    <svg
                                                        className={`w-4 h-4 ml-4 transition-transform ${isDayTypeOpen ? 'transform rotate-180' : ''}`}
                                                        fill="none"
                                                        stroke="currentColor"
                                                        viewBox="0 0 24 24"
                                                    >
                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                                                    </svg>
                                                </button>

                                                {isDayTypeOpen && (
                                                    <>
                                                        <div
                                                            className="fixed inset-0 z-20"
                                                            onClick={() => setIsDayTypeOpen(false)}
                                                        />
                                                        <div className="absolute right-0 mt-1 w-full min-w-[180px] bg-white border border-gray-200 rounded-lg shadow-lg z-30">
                                                            <button
                                                                type="button"
                                                                onClick={() => {
                                                                    setDaySelectionType('all');
                                                                    setIsDayTypeOpen(false);
                                                                }}
                                                                className={`w-full px-4 py-3 text-left ${daySelectionType === 'all'
                                                                    ? 'bg-[#8f1f64]/10 text-[#8f1f64] font-medium'
                                                                    : 'hover:bg-gray-50 text-gray-700'
                                                                    }`}
                                                            >
                                                                Todos los días
                                                            </button>
                                                            <button
                                                                type="button"
                                                                onClick={() => {
                                                                    setDaySelectionType('business');
                                                                    setIsDayTypeOpen(false);
                                                                }}
                                                                className={`w-full px-4 py-3 text-left border-t border-gray-100 ${daySelectionType === 'business'
                                                                    ? 'bg-[#8f1f64]/10 text-[#8f1f64] font-medium'
                                                                    : 'hover:bg-gray-50 text-gray-700'
                                                                    }`}
                                                            >
                                                                Días hábiles
                                                            </button>
                                                        </div>
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Calendario */}
                                <div className="bg-white rounded-xl shadow-md p-6 border border-gray-200">
                                    <DayPicker
                                        mode="range"
                                        selected={range}
                                        onSelect={(dateRange) => {
                                            setRange(dateRange);
                                            if (dateRange?.from) {
                                                const fechaInicio = formatDateWithoutTimezone(dateRange.from);
                                                if (fechaInicio) {
                                                    setFormData(prev => ({
                                                        ...prev,
                                                        fecha_inicio: fechaInicio
                                                    }));
                                                }
                                            }
                                            if (dateRange?.to) {
                                                const fechaFin = formatDateWithoutTimezone(dateRange.to);
                                                if (fechaFin) {
                                                    setFormData(prev => ({
                                                        ...prev,
                                                        fecha_fin: fechaFin
                                                    }));
                                                }
                                            }
                                        }}
                                        disabled={daySelectionType === 'business'
                                            ? { dayOfWeek: [0, 6] }
                                            : undefined
                                        }
                                        numberOfMonths={1}
                                        locale={es}
                                        month={calendarMonth}
                                        onMonthChange={setCalendarMonth}
                                        classNames={{
                                            day: "rounded-full hover:bg-[#8f1f64]/10 transition-all",
                                            caption: "text-gray-700 font-semibold text-center",
                                            nav_button: "hover:bg-[#8f1f64]/10 text-[#8f1f64]",
                                            nav_button_previous: "absolute left-1",
                                            nav_button_next: "absolute right-1",
                                            selected: "bg-[#8f1f64] text-white hover:bg-[#8f1f64] rounded-full",
                                            range_start: "bg-[#8f1f64] text-white hover:bg-[#8f1f64] rounded-full",
                                            range_end: "bg-[#8f1f64] text-white hover:bg-[#8f1f64] rounded-full",
                                            range_middle: "bg-[#8f1f64] text-white hover:bg-[#8f1f64]",
                                            today: "text-[#8f1f64] font-bold aria-selected:text-white",
                                            disabled: "bg-[#8f1f64]/10 text-[#8f1f64]/40 opacity-100"
                                        }}
                                    />
                                </div>

                                {/* Horas */}
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            <Clock className="h-4 w-4 inline mr-2" />
                                            Hora Inicio *
                                        </label>
                                        <input
                                            type="time"
                                            value={formData.hora_inicio}
                                            onChange={(e) => {
                                                setFormData(prev => ({
                                                    ...prev,
                                                    hora_inicio: normalizeTime(e.target.value)
                                                }));
                                                setIsHoraFinManuallyModified(false);
                                            }}
                                            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#8f1f64] focus:border-transparent"
                                            required
                                        />
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            <Clock className="h-4 w-4 inline mr-2" />
                                            Hora Fin {!usaTemporizador && '*'}
                                        </label>
                                        <input
                                            type="time"
                                            value={formData.hora_fin}
                                            onChange={(e) => {
                                                if (!usaTemporizador) {
                                                    setFormData(prev => ({
                                                        ...prev,
                                                        hora_fin: normalizeTime(e.target.value)
                                                    }));
                                                    setIsHoraFinManuallyModified(true);
                                                }
                                            }}
                                            className={`w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-[#8f1f64] focus:border-transparent ${usaTemporizador ? 'bg-gray-100 text-gray-400 cursor-not-allowed' : 'border-gray-300'
                                                }`}
                                            disabled={usaTemporizador}
                                            required={!usaTemporizador}
                                        />
                                        {usaTemporizador && (
                                            <p className="text-xs text-yellow-600 mt-1 flex items-center">
                                                <Clock size={12} className="mr-1" />
                                                Hora de fin se determinará con el temporizador.
                                            </p>
                                        )}
                                    </div>
                                </div>

                                {/* Cantidad de periodos */}
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                        Cantidad de Periodos *
                                    </label>
                                    <input
                                        type="number"
                                        min="1"
                                        value={formData.cantidad_periodos}
                                        onChange={(e) => setFormData(prev => ({
                                            ...prev,
                                            cantidad_periodos: parseInt(e.target.value) || 1
                                        }))}
                                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#8f1f64] focus:border-transparent"
                                        required
                                    />
                                    <p className="text-xs text-gray-500 mt-1">
                                        Número de {selectedPlan?.plan_nombre || 'periodos'} a reservar
                                    </p>
                                </div>

                                {/* Control de Ingreso, Salida y Limpieza */}
                                <div className="space-y-4 pt-4 border-t border-gray-200">
                                    <h3 className="text-lg font-medium text-gray-900 flex items-center gap-2">
                                        <CheckCircle2 className="h-5 w-5 text-[#8f1f64]" />
                                        Control de Ingreso, Salida y Limpieza
                                    </h3>

                                    {/* Ingreso */}
                                    <div className="p-4 bg-gray-50 rounded-xl border border-gray-200 space-y-2">
                                        <div className="flex items-center justify-between">
                                            <label className="text-sm font-bold text-gray-800">
                                                Observaciones de Ingreso
                                            </label>
                                            <label className="flex items-center gap-2 cursor-pointer select-none">
                                                <input
                                                    type="checkbox"
                                                    checked={formData.limpieza_ingreso}
                                                    onChange={(e) => setFormData(prev => ({
                                                        ...prev,
                                                        limpieza_ingreso: e.target.checked
                                                    }))}
                                                    className="w-4 h-4 rounded text-[#8f1f64] focus:ring-[#8f1f64] border-gray-300"
                                                />
                                                <span className="text-xs font-semibold text-gray-700">Espacio limpio al ingresar</span>
                                            </label>
                                        </div>
                                        <textarea
                                            rows={2}
                                            value={formData.observaciones_ingreso}
                                            onChange={(e) => setFormData(prev => ({
                                                ...prev,
                                                observaciones_ingreso: e.target.value
                                            }))}
                                            placeholder="Notas de recepción, estado inicial del espacio, equipamiento..."
                                            className="w-full text-sm p-3 bg-white border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#8f1f64] focus:outline-none resize-none"
                                        />
                                    </div>

                                    {/* Salida */}
                                    <div className="p-4 bg-gray-50 rounded-xl border border-gray-200 space-y-2">
                                        <div className="flex items-center justify-between">
                                            <label className="text-sm font-bold text-gray-800">
                                                Observaciones de Salida
                                            </label>
                                            <label className="flex items-center gap-2 cursor-pointer select-none">
                                                <input
                                                    type="checkbox"
                                                    checked={formData.limpieza_salida}
                                                    onChange={(e) => setFormData(prev => ({
                                                        ...prev,
                                                        limpieza_salida: e.target.checked
                                                    }))}
                                                    className="w-4 h-4 rounded text-[#8f1f64] focus:ring-[#8f1f64] border-gray-300"
                                                />
                                                <span className="text-xs font-semibold text-gray-700">Espacio entregado limpio</span>
                                            </label>
                                        </div>
                                        <textarea
                                            rows={2}
                                            value={formData.observaciones_salida}
                                            onChange={(e) => setFormData(prev => ({
                                                ...prev,
                                                observaciones_salida: e.target.value
                                            }))}
                                            placeholder="Notas de entrega, estado en que dejó el espacio, llaves..."
                                            className="w-full text-sm p-3 bg-white border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#8f1f64] focus:outline-none resize-none"
                                        />
                                    </div>
                                </div>

                                {/* Montos financieros */}
                                <div className="space-y-4">
                                    <h3 className="text-lg font-medium text-gray-900 flex items-center gap-2">
                                        <DollarSign className="h-5 w-5" />
                                        Información Financiera
                                    </h3>

                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Subtotal (Bs)
                                        </label>
                                        <div className="p-3 bg-gray-50 rounded-lg border border-gray-200">
                                            <span className="font-bold text-lg">Bs {formatNumber(formData.subtotal)}</span>
                                            <p className="text-xs text-gray-500 mt-1">
                                                Calculado automáticamente basado en el plan y cantidad de periodos
                                            </p>
                                        </div>
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            <Percent className="h-4 w-4 inline mr-2" />
                                            Descuento Directo (Bs)
                                        </label>
                                        <input
                                            type="number"
                                            min="0"
                                            step="0.01"
                                            value={formData.descuento_directo}
                                            onChange={(e) => setFormData(prev => ({
                                                ...prev,
                                                descuento_directo: parseFloat(e.target.value) || 0
                                            }))}
                                            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#8f1f64] focus:border-transparent"
                                        />
                                    </div>

                                    {/* Cupón */}
                                    <div className="bg-white rounded-lg p-4 border border-gray-200">
                                        <div className="flex items-center justify-between mb-3">
                                            <label className="text-gray-700 text-sm font-medium">Cupón de descuento</label>
                                            <button
                                                type="button"
                                                onClick={validarCupon}
                                                className="px-3 py-1.5 bg-gradient-to-r from-[#8f1f64] to-[#80003a] rounded text-xs font-medium text-white hover:from-[#80003a] hover:to-[#66002e] transition-all shadow-sm"
                                            >
                                                Aplicar
                                            </button>
                                        </div>
                                        <input
                                            type="text"
                                            value={cuponCodigo}
                                            onChange={(e) => setCuponCodigo(e.target.value)}
                                            onBlur={validarCupon}
                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg text-gray-800 focus:outline-none focus:ring-2 focus:ring-[#8f1f64] focus:border-transparent"
                                            placeholder="Ingrese código del cupón"
                                        />
                                        {cuponAplicado && (
                                            <div className="mt-2 p-2 bg-green-50 border border-green-200 rounded-lg">
                                                <div className="flex justify-between items-center">
                                                    <div>
                                                        <p className="text-green-800 font-medium text-sm">Cupón aplicado ✓</p>
                                                        <p className="text-green-600 text-xs">
                                                            {cuponAplicado.codigo} -
                                                            {cuponAplicado.descuento_monto
                                                                ? ` ${cuponAplicado.descuento_monto} Bs.`
                                                                : ` ${cuponAplicado.descuento_porcentaje}%`}
                                                        </p>
                                                    </div>
                                                    <button
                                                        type="button"
                                                        onClick={() => {
                                                            setCuponAplicado(null);
                                                            setCuponCodigo('');
                                                            setFormData(prev => ({ ...prev, cupon: null }));
                                                        }}
                                                        className="p-1.5 text-red-500 hover:text-red-700 hover:bg-red-50 rounded-full transition-colors"
                                                    >
                                                        <X size={16} />
                                                    </button>
                                                </div>
                                            </div>
                                        )}
                                    </div>

                                    {/* Total */}
                                    <div className="p-3 bg-gray-50 rounded-lg">
                                        <div className="flex justify-between items-center">
                                            <span className="font-medium text-gray-700">Total:</span>
                                            <span className="text-xl font-bold" style={{ color: theme.corporate }}>
                                                Bs {formatNumber(formData.total)}
                                            </span>
                                        </div>
                                        <p className="text-xs text-gray-500 mt-1">
                                            Subtotal: Bs {formatNumber(formData.subtotal)} - Descuentos: Bs {formatNumber(formData.descuento_directo + (cuponAplicado?.descuento_monto || 0))}
                                        </p>
                                    </div>
                                </div>

                                {/* Resumen */}
                                <div className="bg-gray-50 rounded-xl p-5 border border-gray-200">
                                    <h3 className="font-bold text-gray-700 mb-4">Resumen de la cita</h3>
                                    <div className="space-y-2">
                                        {selectedCategory && (
                                            <div className="flex justify-between">
                                                <span className="text-gray-600">Categoría:</span>
                                                <span className="font-medium">{selectedCategory.nombre}</span>
                                            </div>
                                        )}
                                        {selectedService && (
                                            <div className="flex justify-between">
                                                <span className="text-gray-600">Servicio:</span>
                                                <span className="font-medium">{selectedService.nombre}</span>
                                            </div>
                                        )}
                                        {selectedPlan && (
                                            <div className="flex justify-between">
                                                <span className="text-gray-600">Plan:</span>
                                                <span className="font-medium">{selectedPlan.plan_nombre}</span>
                                            </div>
                                        )}
                                        {selectedSpace && (
                                            <div className="flex justify-between">
                                                <span className="text-gray-600">Espacio:</span>
                                                <span className="font-medium">{selectedSpace.espacio_nombre}</span>
                                            </div>
                                        )}
                                        <div className="flex justify-between">
                                            <span className="text-gray-600">Períodos:</span>
                                            <span className="font-medium">{formData.cantidad_periodos}</span>
                                        </div>
                                        <div className="flex justify-between">
                                            <span className="text-gray-600">Días:</span>
                                            <span className="font-medium">{daySelectionType === 'all' ? 'Todos' : 'Hábiles'}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {cajaAviso && (
                            <div role="alert" className="mt-6 bg-amber-50 border border-amber-200 text-amber-800 px-4 py-3 rounded-lg text-sm">
                                <span className="font-medium">{cajaAviso}</span>
                            </div>
                        )}

                        {/* Operador de caja: la edición exige el grant sobre la caja persistida de la cita */}
                        <div className="mt-8 pt-6 border-t border-gray-200">
                            {citaSesionPosId === null ? (
                                <p role="note" className="text-sm text-amber-700 bg-amber-50 border border-amber-200 rounded-lg px-3 py-2">
                                    Esta cita no fue registrada en una caja POS: no puede modificarse desde aquí.
                                </p>
                            ) : (
                                <OperadorGrantRow grant={operador.grant} disabled={saving} onIdentify={operador.openDialog} />
                            )}
                        </div>

                        {/* Botones de acción */}
                        <div className="mt-4 flex justify-end gap-4">
                            <button
                                type="button"
                                onClick={() => navigate(`/reservas/detalle/${id}`)}
                                className="px-6 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors"
                            >
                                Cancelar
                            </button>
                            <button
                                type="submit"
                                disabled={saving || !puedeGuardar}
                                title={!puedeGuardar ? 'Identifica al operador de caja con su PIN para guardar' : undefined}
                                className="px-6 py-2 rounded-lg text-white transition-all flex items-center gap-2 disabled:cursor-not-allowed"
                                style={{ backgroundColor: saving || !puedeGuardar ? '#ccc' : theme.primaryAction }}
                            >
                                {saving ? (
                                    <>
                                        <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                                        Guardando...
                                    </>
                                ) : (
                                    <>
                                        <Save className="h-4 w-4" />
                                        Guardar Cambios y Regenerar Sesiones
                                    </>
                                )}
                            </button>
                        </div>
                    </div>
                </form>

                <OperadorPinDialog open={operador.dialogOpen} sesionId={citaSesionPosId} onClose={operador.closeDialog} onGrant={operador.install} />

                {/* Notas importantes */}
                <div className="mt-6 p-4 bg-blue-50 border border-blue-200 rounded-lg">
                    <h3 className="font-medium text-blue-800 mb-2">Notas importantes:</h3>
                    <ul className="text-sm text-blue-700 list-disc list-inside space-y-1">
                        <li>Al modificar fechas u horas, las sesiones asociadas se regenerarán automáticamente.</li>
                        <li>Si el servicio requiere espacio físico, debe seleccionar uno disponible en la sucursal actual.</li>
                        <li>La capacidad del espacio se valida automáticamente con los clientes seleccionados.</li>
                        <li>El total se calcula automáticamente como: Subtotal - Descuentos.</li>
                        <li>La cita mantendrá su código original: {citaOriginal?.codigo || `CITA-${id}`}</li>
                    </ul>
                </div>
            </div>

            {/* Modal para agregar clientes asociados */}
            <ModalAgregarClientesAsociados
                isOpen={showAgregarClientesModal}
                onClose={() => setShowAgregarClientesModal(false)}
                onAgregar={handleAgregarClientesAsociados}
                clientesExcluir={[clienteSeleccionado?.id, ...clientesAsociadosInfo.map(c => c.id)].filter(id => id !== null && id !== undefined) as number[]}
                clientes={clientes}
                capacidadMaxima={selectedSpace ?
                    Math.max(0, selectedSpace.cantidad_personas - 1 - formData.clientes_asociados.length) :
                    undefined
                }
            />
        </div>
    );
};

export default EditarCitaPage;

